import { lazy } from 'solid-js'

export default {
    component: lazy(() => import('../../pages/native-listings-page/native-listings-page.jsx')),
    partnerScoped: true,
    path: '/partners/:partnerSlug/listing/:property_id',
    showCurrencyHeader: true,
    showFooter: true,
    showHeader: true,
    showHeaderMenu: false,
    showSidebar: false,
    showUserHeader: true,
    title: 'Lodgr | Partner Listing',
}
